import axiosIns from '@/utils/axios'

// 获取绑定的就诊人列表
export function loginTeacherApi (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/sys-user/loginTeacher`,
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js